<template>
    <div class="page-wrapper">
        <!-- Loading Overlay -->
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-wrapper">
                <div class="spinner-container">
                    <div class="spinner-outer"></div>
                    <div class="spinner-inner"></div>
                    <img src="../../assets/image/GameClubLogo.png" alt="MTN Logo" class="spinner-logo">
                </div>
                <p class="loading-text">جاري التحميل<span class="dots"><span>.</span><span>.</span><span>.</span></span></p>
            </div>
        </div>

        <!-- Main Content -->
        <div :class="{ 'blur-content': isLoading }">
            <section class="py-5" style="padding-top: 0rem !important;background: #9DB0B0;">
                <top-home />
            </section>
            <section class="pb-5">
                <puzzles-home />
            </section>
            <section class="pb-5">
                <strategy-home />
            </section>
            <section class="pb-5">
                <sports-home />
            </section>
            <section class="pb-5">
                <adventure-home />
            </section>
            <section class="pb-5">
                <arcade-home />
            </section>
        </div>
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import AdventureHome from './HomePage/AdventureHome.vue';
import ArcadeHome from './HomePage/ArcadeHome.vue';
import PuzzlesHome from './HomePage/PuzzlesHome.vue';
import SportsHome from './HomePage/SportsHome.vue';
import StrategyHome from './HomePage/StrategyHome.vue';
import TopHome from './HomePage/TopHome.vue';
import { useCookie } from 'vue-cookie-next';
import { useRouter } from 'vue-router';
import { HTTPMTN } from '@/Api/http-mtn';
import { useToast } from "vue-toastification";
export default {
    name: 'AppHome',
    components: { TopHome, PuzzlesHome, StrategyHome, SportsHome, AdventureHome, ArcadeHome },
    setup() {
        const cookie = useCookie();
        const router = useRouter();
        const toast = useToast();
        const isLoading = ref(false);

        const checkLoginStatus = async (msisdn) => {
            try {
                const response = await HTTPMTN.post(`MTNCheckLogin.php?msisdn=${msisdn}`);
                const { status, remming_minutes, message } = response.data;

                if (status == 1 && message === 'active') {
                    const options = { expire: 60 * remming_minutes };
                    cookie.setCookie('msisdn', msisdn, options);
                    cookie.setCookie('status', status, options);
                    cookie.setCookie('minutes', remming_minutes, options);
                    toast.success('مرحبا بك معنا', { timeout: 1000 });
                    
                } else if (status == -1 && message === 'you are not sub') {
                    cookie.removeCookie('msisdn');
                    toast.error('لست مشترك في هذة الخدمة', { timeout: 1000 });
                } else {
                    cookie.removeCookie('msisdn');
                    toast.error('لست مشترك في هذة الخدمة', { timeout: 1000 });
                }

                // Clear URL parameters and redirect
                setTimeout(() => {
                    window.history.replaceState({}, document.title, window.location.pathname);
                    router.push({ path: '/' });
                }, 2000);
                
            } catch (error) {
                console.error('Error checking login status:', error);
                cookie.removeCookie('msisdn');
                toast.error('حدث خطأ، يرجى المحاولة مرة أخرى', { timeout: 1000 });
                setTimeout(() => {
                    window.history.replaceState({}, document.title, window.location.pathname);
                    router.push({ path: '/' });
                }, 2000);
            } finally {
                isLoading.value = false;
            }
        };

        const delayedLoginCheck = (msisdn) => {
            isLoading.value = true;
            setTimeout(() => {
                checkLoginStatus(msisdn);
            }, 10000);
        };

        watchEffect(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const msisdn = urlParams.get('CGMSISDN') || urlParams.get('msisdn');

            if (msisdn) {
                delayedLoginCheck(msisdn);
            } else {
                setTimeout(() => router.push({ path: '/' }), 2500);
            }
        });

        return {
            isLoading
        };
    },
};
</script>

<style scoped>
.page-wrapper {
    position: relative;
    min-height: 100vh;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    backdrop-filter: blur(5px);
}

.spinner-wrapper {
    text-align: center;
    transform: scale(0.8);
    animation: scaleIn 0.5s ease-out forwards;
}

.spinner-container {
    position: relative;
    width: 120px;
    height: 120px;
    margin: 0 auto;
}

.spinner-outer {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 4px solid transparent;
    border-top-color: #FC0;
    border-right-color: #FC0;
    border-radius: 50%;
    animation: spin 2s linear infinite;
}

.spinner-inner {
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border: 4px solid transparent;
    border-top-color: #ffffff;
    border-left-color: #ffffff;
    border-radius: 50%;
    animation: spin 1.5s linear infinite reverse;
}

.spinner-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    object-fit: contain;
    animation: pulse 2s ease-in-out infinite;
}

.loading-text {
    color: #ffffff;
    font-size: 1.2rem;
    margin-top: 2rem;
    font-weight: 500;
}

.dots span {
    animation: dots 1.5s infinite;
    opacity: 0;
    display: inline-block;
}

.dots span:nth-child(1) { animation-delay: 0.0s; }
.dots span:nth-child(2) { animation-delay: 0.2s; }
.dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes pulse {
    0%, 100% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.1); }
}

@keyframes dots {
    0%, 100% { opacity: 0; }
    50% { opacity: 1; }
}

@keyframes scaleIn {
    from { transform: scale(0.5); opacity: 0; }
    to { transform: scale(0.8); opacity: 1; }
}

.blur-content {
    filter: blur(8px);
    transition: filter 0.3s ease;
}
</style>